import React from "react";
import { Progress } from "antd";

interface MiniMetricProps {
  label: string;
  percentage: number;
  count: number;
  change: number;
  color: string;
  onClick?: () => void;
}

export const MiniMetric: React.FC<MiniMetricProps> = ({
  label,
  percentage,
  change,
  color,
  onClick,
}) => {
  return (
    <div
      style={{
        textAlign: "center",
        padding: "2px",
        cursor: onClick ? "pointer" : "default",
      }}
      onClick={onClick}
    >
      {/* Circular Progress with centered content */}
      <div style={{ position: "relative", display: "inline-block" }}>
        <Progress
          type="circle"
          percent={percentage}
          strokeColor={color}
          strokeWidth={5}
          width={50}
          format={() => (
            <div style={{ textAlign: "center" }}>
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#262626",
                  lineHeight: "14px",
                }}
              >
                {Math.round(percentage)}%
              </div>
              <div
                style={{
                  fontSize: 10,
                  fontWeight: 500,
                  color:
                    change > 0 ? "#52c41a" : change < 0 ? "#ff4d4f" : "#d9d9d9",
                  marginTop: 1,
                }}
              >
                {change === 0
                  ? "—"
                  : `${change > 0 ? "+" : ""}${Math.round(change)}%`}
              </div>
            </div>
          )}
        />
      </div>

      {/* Label */}
      <div
        style={{
          fontSize: 10,
          color: "#8c8c8c",
          marginTop: 4,
          fontWeight: 500,
        }}
      >
        {label}
      </div>
    </div>
  );
};
